import { useIntl } from "react-intl";
import { Box } from "@mui/material";
import {
  WalletCardContainer,
  StyledCurrentTicketLabel,
  StyledRefreshButton,
  StyledIconField,
  StyledFieldLabel,
  StyledFieldValue,
  CopyIconButton,
} from "./UserInfo.style";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import {
  getShortAddress,
  formatNumberWithComma,
  formatDate,
  formatFieldDisplayOrNA,
} from "features/helpers/utils";

export default function WalletCard({
  wallet,
  isSelected,
  onClick,
  index,
  renderRefreshButton,
  sx,
}) {
  const { formatMessage } = useIntl();
  const copyFn = useCopyToClipboard();

  const calculateTotalValue = (wallet) => {
    const totalValue = wallet.walletValues?.reduce((acc, curr) => {
      return acc + Number(curr.value || 0);
    }, 0);

    return totalValue;
  };

  return (
    <WalletCardContainer
      isSelected={isSelected}
      onClick={onClick}
      sx={sx}
      className="general-shadow"
    >
      {/* {showMatchedLabel && (
        <StyledCurrentTicketLabel>
          {formatMessage({ id: "global.label.currentTicket" })}
        </StyledCurrentTicketLabel>
      )} */}

      {renderRefreshButton && (
        <StyledRefreshButton>{renderRefreshButton()}</StyledRefreshButton>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <i className="meta-crm-icon-ic_wallet-1 font-size-16" />
        {formatMessage({ id: "global.commonWord.wallet" })} {index + 1}
      </Box>
      <Box my="16px">
        <StyledIconField sx={{ gap: "5px", flexWrap: "wrap" }}>
          <StyledFieldLabel>
            {formatMessage({ id: "global.commonWord.address" })}
          </StyledFieldLabel>
          <StyledFieldValue>
            {formatFieldDisplayOrNA(getShortAddress(wallet.address))}
          </StyledFieldValue>
          <CopyIconButton
            size={18}
            onClick={(e) => {
              e.stopPropagation();
              copyFn(wallet.address);
            }}
          >
            <i className="meta-crm-icon-ic_copy font-size-16" />
          </CopyIconButton>
        </StyledIconField>
        <StyledIconField sx={{ gap: "5px" }}>
          <StyledFieldLabel>
            {formatMessage({ id: "global.commonWord.ecosystem" })}
          </StyledFieldLabel>

          <StyledFieldValue>
            {formatFieldDisplayOrNA(wallet.ecosystem)}
          </StyledFieldValue>
        </StyledIconField>

        <StyledIconField sx={{ gap: "5px", alignItems: "flex-start" }}>
          <StyledFieldLabel>
            {formatMessage({ id: "global.commonWord.chain" })}
          </StyledFieldLabel>

          <StyledFieldValue>
            {formatFieldDisplayOrNA(wallet.chains.join(", "))}
          </StyledFieldValue>
        </StyledIconField>

        <StyledIconField sx={{ gap: "5px" }}>
          <StyledFieldLabel>
            {formatMessage({ id: "global.commonWord.walletValue" })}
          </StyledFieldLabel>

          <StyledFieldValue>
            {"$" +
              formatFieldDisplayOrNA(
                formatNumberWithComma(calculateTotalValue(wallet))
              )}
          </StyledFieldValue>
        </StyledIconField>

        <StyledIconField sx={{ gap: "5px" }}>
          <StyledFieldLabel>
            {formatMessage({ id: "global.commonWord.walletAge" })}
          </StyledFieldLabel>
          <StyledFieldValue>
            {formatFieldDisplayOrNA(
              wallet.walletAge === "0m" ? "<0m" : wallet.walletAge
            )}
          </StyledFieldValue>
        </StyledIconField>

        <StyledIconField sx={{ gap: "5px" }}>
          <StyledFieldLabel>
            {formatMessage({ id: "global.commonWord.cexLabel" })}
          </StyledFieldLabel>

          <StyledFieldValue>
            {formatFieldDisplayOrNA(wallet.cexLabel)}
          </StyledFieldValue>
        </StyledIconField>
      </Box>

      <StyledFieldLabel sx={{ fontWeight: 400 }}>
        {formatMessage({ id: "global.commonWord.lastUpdated" })}{" "}
        {formatFieldDisplayOrNA(formatDate(wallet.lastUpdted, { time: true }))}
      </StyledFieldLabel>
    </WalletCardContainer>
  );
}
